import React, { useEffect } from "react";
import { GlobalStyles, ThemeProvider } from "./components/primitives";
import { StylesProvider } from "@material-ui/styles";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { createBaseMuiTheme } from "./theme";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import fiConfig from "./fiConfig.json";
import actions from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { populateBillPayPortalDetails } from "./utils/bpportal-common-utils";
import GlobalErrorFocusProvider from "./components/providers/GlobalErrorFocusProvider";

function App() {
  const dispatch = useDispatch();

  const appConfig = useSelector(
    (state) => state.appConfigReducer?.data?.API_BASE_URL
  );
  useEffect(() => {
    if (!appConfig) {
      dispatch(actions.appConfigActions.loadEnvProperties());
    }
  }, []);

  useEffect(() => {
    window.addEventListener("popstate", function () {
      window.history.forward();
    });
  }, []);

  const {fiConfigKey, billPayPortalUrl} = populateBillPayPortalDetails();

  const loadThemeStyle = () => {
    let fiName, fiNumber, type;

    if (fiConfig[fiConfigKey]) {
      ({ fiName, fiNumber, type } = fiConfig[fiConfigKey]);
    } else {
      fiName = "D&D";
      fiNumber = 50;
      type = "admin";
    }

    fiName = fiName.includes("-") ? fiName.split("-")[2] : fiName;
  
    localStorage.setItem("fiNumber", fiNumber === 200 ? 2 : fiNumber);
    localStorage.setItem("type", type);
    localStorage.setItem("fiName", fiName);

    const themeName = `${fiName}.css`;

    return import(`./theme/${themeName}`);
  };

  const muiTheme = createBaseMuiTheme();
  const { i18n } = useTranslation();
  console.log("App loaded");

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <GlobalStyles styles={loadThemeStyle} />
        <GlobalErrorFocusProvider>
          <Router initialEntries={["/"]}>
            <AppRoutes billPayPortalUrl={billPayPortalUrl}/>
          </Router>
        </GlobalErrorFocusProvider>
        <Helmet htmlAttributes={{ lang: i18n.language }} />
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
